const emailRegexp =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const MAX_EMAIL_LENGTH = 255;

const isValidEmail = (email) => {
  if (!email || email.length > MAX_EMAIL_LENGTH) {
    return false;
  }
  return emailRegexp.test(email);
};

export default isValidEmail;
